import Axios from "axios";

// 请求全国省市区信息
const getArea = () => Axios.get("/static/json/area.json");

//获取服务器对象存储密钥，获取访问cos的临时token, subPath即想要存在存储桶中的子目录
const getCosTempToken = (subPath) =>
  Axios.get(`/customer/user/getCosTempToken?subPath=${subPath}`);

//新增网点
const addPos = (params) => Axios.post("/customer/omc/addPos", params);
/*
 * posInfo{
 *   partnerId,
 *   name,
 *   contact,
 *   phone,
 *   accessType,
 *   openhoursV2,
 *   address,
 *   province,
 *   city,
 *   district,
 *   longitude,
 *   latitude,
 *   ywbTag,
 *   washerType,
 *   lstPicUrls
 * }
 * 边缘接入参数必须填写
 * deviceInfo{
 *   deviceName
 *   token
 * }
 * */

// 删除门店
const delPos = (posId) => Axios.get(`/customer/omc/delPos?posId=${posId}`);

// 修改门店
const modPos = (params, openId) =>
  Axios.post(`/customer/omc/modPos?openId=${openId}`, params);

// 审批雇员申请
const approveStaffApply = (applyId, applyState) =>
  Axios.get(
    `/customer/ditan/approveStaffApply?applyId=${applyId}&applyState=${applyState}`
  );

// 添加商家
const addPartner = (openId, params) =>
  Axios.post(`/customer/omc/addPartner?openId=${openId}`, params);

// 修改商家
const modPartner = (openId, params) =>
  Axios.post(`/customer/omc/modPartner?openId=${openId}`, params);

// 添加产品
const addProduct = (openId, params) =>
  Axios.post(`/customer/omc/addProduct?openId=${openId}`, params);

// 修改产品
const modProduct = (openId, productType, params) =>
  Axios.post(
    `/customer/omc/modifyProduct?openId=${openId}&productType=${productType}`,
    params
  );

// 网点产品下架
const productConfig = (openId, params) =>
  Axios.post(`/customer/omc/productConfig?openId=${openId}`, params);
// posId
// productType  0下架 1上架

// 新增微信支付商户
const addWePayMerchant = (params) =>
  Axios.post("/customer/omc/addWePayMerchant", params);

// 修改微信支付方式
const modWepayMerchant = (partnerId, payMethod) =>
  Axios.get(
    `/customer/omc/modWepayMerchant?partnerId=${partnerId}&payMethod=${payMethod}`
  );

// 修改网点合作申请
const modPosJoinApply = (applyId, params) =>
  Axios.post(`/customer/ditan/modifyPosJoinApply?applyId=${applyId}`, params);

// 审批微信支付商户
const approveWePayMerchant = (params) =>
  Axios.post(`/customer/omc/approveWePayMerchant`, params);

//上传网点申报信息
const uploadPosApplyDetail = (params) => Axios.post(`/zmdp/myUrls`, params);

//查询上传的网点申报的信息
const queryUploadPosApplyDetail = (params) => Axios.get(`/zmdp/myUrls?page=${params.page}&size=${params.size}`);

const userQueryUploadPosApply = (params) => Axios.get(`/zmdp/myUrls/search/findByUserAccount?userAccount=${params.userAccount}`)

// 门店商户迁移
const modPosPartner = (params) => Axios.get(`/customer/omc/modPosPartner?posId=${params.posId}&partnerId=${params.partnerId}`)

//管理员确认订单完成
const orderComplete = (orderId) => Axios.get(`/customer/omc/orderComplete?orderId=${orderId}`);

// 手工协助消息通知
const manualNotify = (params) => Axios.post(`/customer/user/manualNotify`, params);
/*
* openId
* orderId
* msg
* */

// 管理员协助用户订单退款
const refund = (params) => Axios.get(`/customer/omc/refund?orderId=${params.orderId}`);

// 管理员启动洗车机
const adminStartWash = (params) => Axios.post(`/customer/omc/adminStartWash?orderId=${params.orderId}`);

//查询用户行为日志
const getUserEventLog = (openid)=>Axios.get(`/customer/user/getEventLog?userAccount=${openid}`)   //?userAccount=${params.userAccount}

//查询在线用户
const getOnlineUserList= ()=>Axios.post(`/customer/user/getOnlineUser?page=1&size=1000`)   //?userAccount=${params.userAccount}

const addEventLog = (params) => Axios.post('/customer/user/addEventLog',params);

// 回复评论
const replyUserComment = (params) => Axios.post(`/customer/user/commentReply`,params);

// 管理员修改评论状态
const modCommentStatus = (params) => Axios.post('/customer/user/modComment',params);

// 修改车好靓token的接口
const modChehaoliangToken = (token) => Axios.get(`/customer/omc/modChehaoliangToken?token=${token}`)

//获取baidu声音token
const getTTSToken = () => Axios.get(`/customer/user/getBaiduAccessToken`);

export {
  getArea,                   // 请求全国省市区信息
  getCosTempToken,           // 获取服务器对象存储密钥，获取访问cos的临时token, subPath即想要存在存储桶中的子目录
  addPos,                    // 新增网点
  delPos,                    // 删除门店
  modPos,                    // 修改门店
  approveStaffApply,         // 审批雇员申请
  addPartner,                // 添加商家
  modPartner,                // 修改商家
  addProduct,                // 添加产品
  modProduct,                // 修改产品
  productConfig,             // 网点产品下架
  addWePayMerchant,          // 新增微信支付商户
  modWepayMerchant,          // 修改微信支付商户
  modPosJoinApply,           // 修改网点合作申请
  approveWePayMerchant,      // 审批微信支付商户
  uploadPosApplyDetail,      // 上传网点申报信息
  queryUploadPosApplyDetail, // 查询上传网点申报信息
  userQueryUploadPosApply,   // 用户查询网点申报列表
  modPosPartner,             // 门店商户迁移
  orderComplete,             // 管理员确认订单完成
  manualNotify,              // 手工协助消息通知
  refund,                    // 管理员协助用户订单退款
  adminStartWash,            // 管理员启动洗车机
  getTTSToken,               // 获取百度声音token
  getUserEventLog,           // 查询用户行为日志
  getOnlineUserList,         // 查询在线用户列表
  addEventLog,               // 添加管理员行为日志
  replyUserComment,          // 回复评论
  modCommentStatus,          // 管理员修改评论状态
  modChehaoliangToken,       // 修改车好靓token
};



// WEBPACK FOOTER //
// ./src/api/index.js